export default __webpack_public_path__ + "static/media/kubek1.d167c807.jpg";